import i18next from 'i18next';

i18next.addResources('en', 'SYSTEM_STATUS', {
  TITLE: 'System Status',
  CONFIG_DESCRIPTION: 'Manage platform public visibility and user access.',
  MAINTENANCE_MODE_LABEL: 'Maintenance Mode (Blocks user access)',
  SHOW_LANDING_LABEL: 'Show initial Landing Page',
  DESCRIPTION_OFF: 'The system is operating normally.',
  DESCRIPTION_MAINTENANCE: 'The maintenance page with help contact will be displayed.',
  DESCRIPTION_LANDING: 'The Landing Page with Beneemeth information will be displayed.',
});

i18next.addResources('es', 'SYSTEM_STATUS', {
  TITLE: 'Estado del Sistema',
  CONFIG_DESCRIPTION: 'Gestione la visibilidad pública de la plataforma y el acceso de usuarios.',
  MAINTENANCE_MODE_LABEL: 'Modo Mantenimiento (Bloquea el acceso a usuarios)',
  SHOW_LANDING_LABEL: 'Mostrar Landing Page inicial',
  DESCRIPTION_OFF: 'El sistema está operando normalmente.',
  DESCRIPTION_MAINTENANCE: 'Se mostrará la página de mantenimiento con contacto de ayuda.',
  DESCRIPTION_LANDING: 'Se mostrará la Landing Page con información de Beneemeth.',
});
